// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fx","advertDetailHeaderPrice__value":"c-m_fy","advertDetailHeaderPrice__label":"c-m_fz"};